<template>
  <a-form-model ref="form" :model="form" :rules="rules">
    <a-form-model-item :label="$t('腾讯云')+$t('邮件密匙ID')" prop="apiKey" >
      <a-input v-model="form.apiKey" :placeholder="$t('请输入')+$t('腾讯云')+$t('邮件SecretId')" />
    </a-form-model-item>
    <a-form-model-item :label="$t('腾讯云')+$t('密钥SECRET')" prop="apiSecret" >
      <a-input v-model="form.apiSecret" :placeholder="$t('请输入')+$t('腾讯云')+$t('邮件SecretKey')" type="password" />
    </a-form-model-item>
    <a-form-model-item prop="apiRegion" :label="$t('腾讯云')+$t('区域ID')" >

      <a-input v-model="form.apiRegion" :placeholder="$t('请输入')+$t('腾讯云')+$t('邮件RegionId')"/>
    </a-form-model-item>

    <a-form-model-item :wrapper-col="{ span: 18, offset: 10 }">
      <a-button type="primary" :loading="submitLoading" @click="submitForm">
        {{ $t('保存') }}
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { getEmailChannel, updateEmailChanne } from '@/api/email/channel'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      // 表单参数
      form: {
        id: null,
        apiKey: null,
        apiSecret: null,
        apiRegion: null
      },
      rules: {
        apiKey: [
          { required: true, message: this.$t('腾讯云') + this.$t('邮件SecretId') + this.$t('不能为空'), trigger: 'blur' }
        ],
        apiSecret: [
          { required: true, message: this.$t('腾讯云') + this.$t('邮件SecretKey') + this.$t('不能为空'), trigger: 'blur' }
        ],
        apiRegion: [
          { required: true, message: this.$t('腾讯云') + this.$t('邮件RegionId') + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    getEmailChannel('TENCENT').then(respons => {
      this.form = respons.data
    })
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateEmailChanne(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
